<template>
	<div>
		<div class="c-mobile-nav-overlay" :class="{ '--open' : $store.state.mobileNavOpen }"></div>
		<div 
			class="c-mobile-nav psdm" 
			:class="{ 'c-mobile-nav--open' : $store.state.mobileNavOpen }"
			@focusout="onClose"
			tabindex="-1"
			ref="mobileNav"
		>
			<a class="d-block mb-12 pl-8" href="#" @click.prevent="onClose">
				<icon-close color="#8E8E8E" />
			</a>
			<div class="c-mobile-nav__section mb-5">
				<div v-if="authenticated && me" class="text-center mb-6 pb-6 border-bottom border-lightgrey u-position-relative">
					<img class="c-profile-dropdown__avatar d-block mb-2 ml-8" :src="profileImage" :alt="profileName" />
					<div
						class="c-profile-dropdown d-flex align-items-center mx-6 px-2"
						:class="{ '--active' : showProfileMenu}"
						@click="toggleProfileMenu"
					>
						<span class="mr-auto d-block">My account</span>
						<icon-drop-arrow color="#4B4B4B" />
					</div>
					<div v-show="showProfileMenu" class="c-submenu px-8 mt-8">
						<ul>
							<li v-if="me.type != 'REGION_ADMIN'" class="mb-6"><a class="font_16_21" :href="`/region-profiles/${profileName}`">View my profile</a></li>
							<li v-if="me.type != 'REGION_ADMIN'" class="mb-6"><a class="font_16_21" href="/region-profiles/me/edit">Build my profile</a></li>
							<li><ps-logout button-classes="c-button c-button--style-2 w-100"></ps-logout></li>
						</ul>
					</div>
				</div>
				<div v-else class="text-center mb-6 px-8">
					<a href="#" class="c-button c-button--style-2 mr-5" @click.prevent="toggleModal('login')">Login</a>
					<a href="#" class="c-button c-button--style-1" @click.prevent="toggleModal('join')">Join</a>
				</div>
				<form class="d-flex u-position-relative px-8" method="get" action="/">
					<icon-search class="d-block c-search-icon flex-shrink-0" color="#000000" />
					<input class="c-search-input" type="search" name="s" placeholder="Search by keyword" />
				</form>
			</div>
			<div v-if="urlSegment == 'tools-and-resources'" class="c-mobile-nav__section">
				<li class="c-mobile-nav__menu-item px-8"><a href="/tools-and-resources" class="text-primary font_18_24 py-5 d-block">Tools &amp; resources</a></li>
				<li class="c-mobile-nav__menu-item">
					<a @click.prevent="openItem" href="#" class="c-mobile-nav__menu-item text-primary font_18_24 px-8 py-5 d-flex justify-content-between align-items-center"><span>My city's resources</span> <icon-drop-arrow class="c-mobile-nav__drop-indicator" color="#4B4B4B" /></a>
					<ul class="c-mobile-nav__menu c-mobile-nav__menu--sub">
						<li class="c-mobile-nav__menu-item px-8"><a href="#" class="text-primary font_18_24 py-5 d-block" @click.prevent.stop="reloadWithHash('myResources')"><icon-home class="mr-3" color="#4B4B4B" /> <span>Dashboard</span></a></li>
						<li class="c-mobile-nav__menu-item px-8"><a href="#" class="text-primary font_18_24 py-5 d-block" @click.prevent.stop="setMyResourcePage('saved-resources')"><icon-bookmark class="mr-3" color="wh#4B4B4Bi#4B4B4Bte" /> <span>Saved resources</span></a></li>
						<li class="c-mobile-nav__menu-item px-8"><a href="#" class="text-primary font_18_24 py-5 d-block" @click.prevent.stop="setMyResourcePage('uploads')"><icon-upload class="mr-3" color="#4B4B4B" /> <span>My city’s uploads</span></a></li>
						<!-- <li class="c-mobile-nav__menu-item px-8"><a href="#" class="text-primary font_18_24 py-5 d-block" @click.prevent.stop="setMyResourcePage('downloads')"><icon-download class="mr-3" color="#4B4B4B" /> <span>Downloads</span></a></li> -->
					</ul>
				</li>
				<li class="c-mobile-nav__menu-item px-8"><a href="#" class="text-primary font_18_24 py-5 d-block" @click.prevent="reloadWithHash('UploadResource')">Upload resource</a></li>
			</div>
			<div class="c-mobile-nav__section">
				<ul class="c-mobile-nav__menu">
					<li class="c-mobile-nav__menu-item px-8"><a href="/" class="text-primary font_18_24 py-5 d-block">Home</a></li>
		
					<li class="c-mobile-nav__menu-item">
						<a @click.prevent="openItem" href="#" class="c-mobile-nav__menu-item-link text-primary font_18_24 px-6 mx-2 py-5 d-flex justify-content-between align-items-center"><span>For regions</span> <icon-drop-arrow class="c-mobile-nav__drop-indicator" color="#4B4B4B" /></a>
						<ul class="c-mobile-nav__menu c-mobile-nav__menu--sub">
							<li v-if="authenticated" class="c-mobile-nav__menu-item px-8">
								<a class="text-primary font_18_24 py-5 d-block" href="/actions-dashboard/">Action platform</a>
							</li>
							<li v-else class="c-mobile-nav__menu-item px-8">
								<a class="text-primary font_18_24 py-5 d-block" href="/actions/">Action platform</a>
							</li>
							<li class="c-mobile-nav__menu-item px-8">
								<!--<a class="text-primary font_18_24 py-5 d-block" href="/guides/">Guides</a>-->
							</li>
						</ul>
					</li>
					<li class="c-mobile-nav__menu-item">
						<a @click.prevent="openItem" href="#" class="c-mobile-nav__menu-item-link text-primary font_18_24 px-6 mx-2 py-5 d-flex justify-content-between align-items-center"><span>For communities</span> <icon-drop-arrow class="c-mobile-nav__drop-indicator" color="#4B4B4B" /></a>
						<ul class="c-mobile-nav__menu c-mobile-nav__menu--sub">
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/tools-and-resources/">Tools &amp; resources</a></li>
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/region-profiles/">Region profiles</a></li>
						</ul>
					</li>
					<li class="c-mobile-nav__menu-item">
						<a @click.prevent="openItem" href="#" class="c-mobile-nav__menu-item-link text-primary font_18_24 px-6 mx-2 py-5 d-flex justify-content-between align-items-center"><span>Info</span> <icon-drop-arrow class="c-mobile-nav__drop-indicator" color="#4B4B4B" /></a>
						<ul class="c-mobile-nav__menu c-mobile-nav__menu--sub">
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/what-our-regions-are-doing/">What our regions are doing</a></li>
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/the-case-study-database">Case study database</a></li>
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/newsletters/">Buzz newsletters</a></li>
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/updates">News</a></li>
							<li class="c-mobile-nav__menu-item px-8"><a class="text-primary font_18_24 py-5 d-block" href="/contact">Contact</a></li>
						</ul>
					</li>
				</ul>
				<div class="d-flex px-8 mt-8">
					<a class="mr-8" href="https://bsky.app/profile/citieswithnature.org" target="_blank" rel="nofollow noopener">
						<icon-bluesky class="d-block" color="#8E8E8E" />
					</a>
					<a class="mr-8" href="https://www.linkedin.com/company/citieswithnature-regionswithnature" target="_blank" rel="nofollow noopener">
						<icon-linkedin class="d-block" color="#8E8E8E" />
					</a>
					<a href="mailto:info@regionswithnature.org">
						<icon-mail class="d-block" color="#8E8E8E" />
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import profile from '../mixins/Profile'

export default {
	name: 'PsMobileNavigation',
	data: () => ({
		showProfileMenu: false,
		searchTerm: ''
	}),
	methods: {
		toggleModal(content) {
			// this.showLogin = content == 'login' ? true : false

			this.$store.commit('setMobileNav', false)

			if (content == 'login') {
				this.$store.commit('setShowLogin', true)
			}
			else {
				this.$store.commit('setShowLogin', false)
			}

			this.$store.commit('toggleLoginModel')

			//Cancel login attempt if it is in progress
			// if (this.submitting) {
			// 	this.cancelSource.cancel('Cancelled by user')
			// 	this.submitting = false
			// }

			//Add class to body if modal is open
			document.querySelector('body').classList.toggle('with-modal')
		},

		// openItem($event) {
		// 	$event.currentTarget.classList.toggle('c-mobile-nav__menu-item--open')
		// },

		openItem($event) {
		  const parent = $event.currentTarget.parentNode;
		  parent.classList.toggle('c-mobile-nav__menu-item--open');
		},

		reloadWithHash(hash) {
			window.location.hash = '#' + hash
			window.location.reload(true)
		},

		setMyResourcePage(page) {
			this.$store.commit('setMyResourcesActivePage', page)
			this.$store.commit('setMobileNav', false)
		},

		toggleProfileMenu() {
			this.showProfileMenu = !this.showProfileMenu
		},

		onClose(event) {
			if (!event.currentTarget.contains(event.relatedTarget)) {
				this.$store.commit('setMobileNav', false)
				this.$store.commit('setActiveNavSubmenu', false)
			}
		},

		submitSearch() {
			window.location.href = '/?s=' + this.searchTerm
		},
	},
	computed: {
		...mapGetters({
			authenticated: 'authenticated',
			me: 'getMe',
			hasNoCity: 'hasNoCity',
		}),

		urlSegment() {
			var url = window.location.href
			var segments = url.split('/')

			return segments[3]
		},

		profileName() {
			if (this.me.type == 'REGION_ADMIN') {
				return this.me.regional_office.name
			}

			if (this.hasNoCity) {
				return this.me.first_name
			}

			if (this.me.cities) {
				return this.me.cities[0].name
			}

			return 'N/A'
		}
	},
	mixins: [profile]
}
</script>

<style lang="scss" scoped>

	.c-mobile-nav-overlay {
		position: fixed;
		width: 100vw;
		height: 100vh;
		background: #231F20;
		opacity: 0.5;
		display: none;
		z-index: 3;

		&.--open {
			display: block;
		}
	}
	.c-mobile-nav {
		position: absolute;
		height: 100%;
		top: 0px;
		transform: translateX(-100%);
		width: $mobile-nav-width;
		background: white;
		z-index: 3;
		transition: all 0.5s ease;
		padding: 43px 0;

		@media only screen and (min-width: 1024px) {
			transform: translateX(-100%) !important;
		}

		li {
			list-style: none;
		}

		&__section {
			border-bottom: 1px solid #FFFFFF;
		}

		&__menu {
			list-style: none;
			margin: 0;
			padding: 0;

			&--sub {
				max-height: 0;
				overflow: hidden;
				transition: all .5s ease;
				padding-left: 24px;
			}
		}

		&__menu-item {
			border-bottom: 1px solid rgba(255, 255, 255, 0.1);
			transition: 0.5s ease;

			&:last-child {
				border-bottom: none;
			}

			a {
				text-decoration: none;
			}

			&--open {
				background-color: white;

				.c-mobile-nav__menu-item-link {
					background-color: #E9F3F3;
					border-radius: 4px;
					color: $ocean-blue;
				}

				.c-mobile-nav__drop-indicator {
					transform: rotate(180deg)
				}

				.c-mobile-nav__menu--sub {
					max-height: 800px;
				}
			}
		}

		&__drop-indicator {
			transition: all 0.5s ease;
		}

		&--open {
			transform: translateX(0%);
		}

		&:focus {
			outline: none;
		}
	}

	ul {
		margin: 0;
		padding: 0;
	}

	li {
		list-style: none;
	}

	.c-profile-dropdown {
		height: 39px;
		border-radius: 4px;
		cursor: pointer;

		&__avatar {
			border-radius: 50%;
			width: 60px;
			height: 60px;

			@include media-breakpoint-up(lg) {
				width: 30px;
				height: 30px;
			}
		}

		&.--active {
			background-color: #E9F3F3;
			color: $ocean-blue;
		}
	}

	 .c-submenu {
		background: white;
		margin-left: 24px;
		min-width: 236px;
		text-align: left;

		a {
			color: $black;
			transition: all 0.3s ease;

			&:hover {
				color: $tropical-tangerine;
			}
		}
	}

	.c-search-input {
		border: 1px solid #E5E5E5;
		box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.02), 0px 2px 4px rgba(0, 0, 0, 0.04);
		border-radius: 4px;
		padding-left: 48px;
		width: 100%;
		height: 48px;
	}

	.c-search-icon {
		position: absolute;
		left: 45px;
		top: 14px;
		z-index: 2;
	}

</style>